export const cilRemove = ["24 24","<path d='M10.655 17.030l3.97-3.97 3.97 3.97 1.061-1.061-3.97-3.97 3.97-3.97-1.061-1.061-3.97 3.97-3.97-3.97-1.061 1.061 3.97 3.97-3.97 3.97 1.061 1.061z'></path><path d='M22.125 3h-13.001c-0.321 0.001-0.611 0.135-0.816 0.351l-0 0-7.557 7.975v1.348l7.557 7.975c0.206 0.216 0.495 0.351 0.816 0.351h13.001c0.621-0.001 1.124-0.504 1.125-1.125v-15.75c-0.001-0.621-0.504-1.124-1.125-1.125h-0zM21.75 19.5h-12.465l-7.035-7.424v-0.152l7.035-7.424h12.465z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-remove.js
// module id = null
// module chunks = 